import React from 'react';
import { Form, Button } from '@blueprintnyc/bpnyc-common';
import { Toggle } from '@blueprintnyc/bpnyc-common-admin';
import ColorInput from 'components/ColorInput';
import EventGroupsPicker from '@/components/EventGroupsPicker';

const HeaderWidgetOptions = props => {
	const {
		event,
		widgetToUpdate,
		handleChange,
		widgetProps,
		handlePropChange,
		onUpdate,
		handleGroupChange,
		targetKeys,
	} = props;
	const { headerColor, dividerColor } = widgetProps;

	return (
		<Form initialValues={widgetToUpdate.props} onChange={handleChange}>
			<div className="WidgetUpdateForm">
				<Form.Item label="Header Text" name="headerText">
					<Form.Input />
				</Form.Item>
				<Form.Item label="Header Alignment" name="alignment">
					<Toggle toggleOptions={['left', 'center', 'right']} />
				</Form.Item>
				<Form.Item label="Header Size" name="headerSize">
					<Toggle toggleOptions={['small', 'medium', 'large']} />
				</Form.Item>
				<Form.Item label="Text Color" name="headerColor">
					<ColorInput
						color={headerColor}
						onChange={hex => handlePropChange('headerColor')(hex)}
						eventID={event.id}
					/>
				</Form.Item>
				<Form.Item label="Divider Color" name="dividerColor">
					<ColorInput
						color={dividerColor}
						onChange={hex => handlePropChange('dividerColor')(hex)}
						eventID={event.id}
					/>
				</Form.Item>
				<h4 className="admin-form-item-label">Group Permissions</h4>
				<div className="groups-picker">
					<EventGroupsPicker
						event={event}
						handleChange={handleGroupChange}
						targetKeys={targetKeys}
					/>
				</div>
			</div>
			<Button type="submit" style={{ marginTop: '15px' }} onClick={() => onUpdate(widgetProps)}>
				Submit
			</Button>
		</Form>
	);
};

export default HeaderWidgetOptions;
